/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faDownload} from '@fortawesome/pro-duotone-svg-icons';

const AdtDashboardIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faDownload} {...props} />
);

export default AdtDashboardIcon;
